import { render, staticRenderFns } from "./BioBreakConfirmation.vue?vue&type=template&id=a8483272&"
import script from "./BioBreakConfirmation.vue?vue&type=script&lang=js&"
export * from "./BioBreakConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports